export default __webpack_public_path__ + "static/media/hotcross-bnb.c43081eb.svg";